/**
 * Maps credit card type keys to their display labels.
 *
 * - AMERICAN_EXPRESS: 'Amex'
 * - DISCOVER: 'Discover'
 * - MC: 'Master Card'
 * - VI: 'Visa'
 */
export const creditCardTypeMap = {
  AMERICAN_EXPRESS: 'Amex',
  DISCOVER: 'Discover',
  MC: 'Master Card',
  VI: 'Visa',
};
